module.exports = "/packs/media/images/icons/contract-38abb6f70d699652330df78c1d4cf36e.png";